import { render, staticRenderFns } from "./ForgotPwd.vue?vue&type=template&id=61253be7&scoped=true&"
import script from "./ForgotPwd.vue?vue&type=script&lang=ts&"
export * from "./ForgotPwd.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPwd.vue?vue&type=style&index=0&id=61253be7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61253be7",
  null
  
)

export default component.exports